import { MetricsContextProvider } from 'modules/productAnalytics/context';
import { JourneyMetrics, MetricsSettingsProps } from './JourneyMetrics';

const PAGE = 'CampaignAnalytics';

export const Metrics = (props: MetricsSettingsProps) => {
  return (
    <MetricsContextProvider page={PAGE}>
      <JourneyMetrics {...props} />
    </MetricsContextProvider>
  );
};
